<!--
 * @Descripttion: 育儿日历
 * @Author: Niu Chenxin
 * @Date: 2021-01-12 13:18:15
 * @LastEditors: taoyan taoyan_work@163.com
 * @LastEditTime: 2022-11-03 09:42:23
-->

<template>
  <div class="calendar">
    <div class="back" @click.stop="goBack" v-show="showBack">
      <van-icon name="arrow-left" size="20px" />
    </div>
    <div class="calendar_tab">
      <!-- 标签导航栏 -->
      <van-tabs
        class="tabs"
        line-width="40px"
        line-height="5px"
        title-inactive-color="#333333"
        title-active-color="#ffffff"
        v-model="curType"
        @click="switchPage"
      >
        <!-- 日历 -->
        <van-tab title="漫画说育儿" class="tab1_list">
          <parentingCalen :ABtest="''" @weShare="weShare"></parentingCalen>
        </van-tab>
        <!-- 音频 -->
        <van-tab title="星妈讲故事" class="tab2_list">
          <parentAudio
            ref="audioItem"
            @shareToast="shareToast"
            @isEmpty="isEmpty"
            :ABtest="''"
            :isAudioChild="isAudioChild"
          ></parentAudio>
        </van-tab>
        <!-- 儿歌 -->
        <van-tab title="儿歌游戏" class="tab3_list">
          <childSongs
            @shareToast="shareToast"
            :ABtest="''"
            :isVideoState="isVideoState"
          ></childSongs>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 分享提示弹窗 -->
    <shareToast v-if="shareToastShow" @shareToast="shareToast"></shareToast>
    <audioShare ref="share"></audioShare>
    <!-- 空数据提示 -->
    <emptyList v-if="emptyList"></emptyList>
  </div>
</template>

<script>
//  亲子儿歌
import childSongs from '@/components/contents/calendar/childSongs.vue'
//  育儿音频
import parentAudio from '@/components/contents/calendar/parentAudio_1.0.vue'
//  育儿日历
import parentingCalen from '@/components/contents/calendar/parentingCalen.vue'
// 分享提示弹窗
import shareToast from '@/components/contents/calendar/shareToast.vue'
//音频接口
import API from '@/utils/axiosApi/parentingAudioAPI.js'
//分享弹窗
import audioShare from '@/components/comment/share.vue'
// 数据为空组件
import emptyList from '@/components/contents/emptyList.vue'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent'
import { getCookie, is_weixin, setCookie } from '@/assets/js/common.js' //工具类
export default {
  name: 'calendar',
  data() {
    return {
      curType: 0,
      shareToastShow: false, // 分享弹窗显示
      // isPlayAudioChild: false, //音频跳转时  控制是否暂停播放
      isAudioChild: false, //控制音频是否展示
      emptyList: false,
      isVideoState: false, // 视频跳转时 是否暂停播放
      shareDataParams: {},
      showBack: true,
    }
  },
  mounted() {
    let curType
    if (
      this.$route.query.shareFrom == 'audio' ||
      localStorage.getItem('tabNum') == 1
    ) {
      this.curType = 1
    } else if (
      this.$route.query.shareFrom == 'songs' ||
      localStorage.getItem('tabNum') == 2
    ) {
      this.curType = 2
    } else {
      this.curType = 0
    }
    BuiedPointClick_Fn('xmhH5_meiriyuerpage_view', {
      xmhH5_meiriyuer_tabname:
        (this.curType == 0 && '育儿日历') ||
        (this.curType == 1 && '星妈讲故事') ||
        (this.curType == 2 && '儿歌动画'),
      xmhH5_meiriyuer_view_source: this.$route.query.source,
    })
    this.showBack =
      this.$route.query.crmId || this.$route.query.crmId == '' ? false : true
    this.weShare()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit('changeIncludes', ['home'])
      console.log(vm.$store)
    })
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面进入详情不清空数据，
    if (to.name != 'audiodetail' && to.name != 'parentchildsongsdetail') {
      localStorage.removeItem('tabNum')
    }
    this.isPlayAudioChild = false //离开时暂停音乐播放并保存播放进度
    sessionStorage.removeItem('audioIndex')
    if (this.$refs.audioItem) {
      this.$refs.audioItem.cancelPlay()
    }
    next()
  },
  components: {
    childSongs,
    parentAudio,
    parentingCalen,
    shareToast,
    audioShare,
    emptyList,
  },
  methods: {
    goBack() {
      if (this.$route.query.shareFrom) {
        this.$router.go(-1)
      } else {
        const sourceFrom = this.$route.query.sourceFrom
        sourceFrom
          ? this.$router.push(sourceFrom)
          : this.$router.push({ path: '/home' })
      }
    },
    // 微信分享
    weShare(id) {
      var shareTitle, shareDesc, imgUrl
      var sharePage = 'calendar'
      if (this.curType == 1) {
        // 星妈讲故事
        shareTitle = '星妈讲故事'
        shareDesc =
          '星妈会，一天一个故事，用爱养育宝宝，用心陪伴孩子，记得带宝宝天天来听哦！'
        sharePage = 'audio'
        imgUrl = 'https://image-mom.feihe.com/wxshare/xingmajianggushi.jpg'
      } else if (this.curType == 2) {
        // 儿歌游戏
        shareTitle = '儿歌动画'
        shareDesc =
          '经典儿歌、益智动画、手工游戏，宝宝的最爱，记得带宝宝天天来学习哦~'
        sharePage = 'songs'
        imgUrl = 'https://image-mom.feihe.com/wxshare/home.png'
      } else {
        sharePage = 'calendar'
        shareTitle = '漫画说育儿'
        shareDesc = '看漫画，学育儿，轻松解决育儿难题'
        imgUrl = 'https://image-mom.feihe.com/wxshare/calendar.jpg'
      }
      this.shareDataParams = {
        // 育儿日历
        shareFlag: true,
        shareLink: location.origin + '/calendar?shareFrom=' + sharePage,
        shareDesc: shareDesc,
        shareTitle: shareTitle,
        imgUrl: imgUrl, //必须是绝对路径
        shareid: id ? id : '',
        shareType: this.$route.query.shareFrom,
      }
      this.wxJsSet.wxShare('fx', this.shareDataParams, this)
    },
    switchPage(index) {
      localStorage.setItem('tabNum', index)
      this.weShare()
      this.emptyList = false
      this.isVideoState = false

      // this.isPlayAudioChild = false; //离开时暂停音乐播放并保存播放进度
      if (this.$refs.audioItem) {
        if (this.$refs.audioItem.audioList.length > 0) {
          this.$refs.audioItem.cancelPlay()
        }
      }
      if (this.curType == 1) {
        this.isAudioChild = true
      } else if (this.curType == 2) {
        this.isVideoState = true
        this.isAudioChild = false
      } else {
        this.isAudioChild = false
      }
      BuiedPointClick_Fn('xmhH5_meiriyuerpage_view', {
        xmhH5_meiriyuer_tabname:
          (this.curType == 0 && '育儿日历') ||
          (this.curType == 1 && '星妈讲故事') ||
          (this.curType == 2 && '儿歌动画'),
        xmhH5_meiriyuer_view_source: this.$route.query.source,
      })
    },
    // 分享弹窗显示
    shareToast(flag, id) {
      // this.shareDataParams.shareid = id
      // this.shareDataParams.shareType = this.$route.query.shareFrom
      if (flag) {
        this.weShare(id)
      }
      this.shareToastShow = flag
    },
    // 列表数据为空显示
    isEmpty(flag) {
      this.emptyList = flag
    },
    getCookie,
    setCookie,
  },
}
</script>

<style lang="less" scoped>
@import './../../../assets/less/contents/calendar/calendar.less';
</style>
